// extracted by mini-css-extract-plugin
module.exports = {"container":"patient-tests-dropdown-container-module__container___sH5HW","downloadButton":"patient-tests-dropdown-container-module__downloadButton___2xIXj"};